import routes from "./billingRoutes";
import store from "./billingStore";
import checkout from "./components/checkout";

export default {
  install(Vue, options) {
    options.router.addRoute(...routes);
    options.store.registerModule("Billing", store);

    options.store.commit("Dashboard/SET_SET_MENU", {
      to: { name: "Billing" },
      icon: "mdi-credit-card",
      title: "Billing",
    });

    Vue.component("checkoutComponent", checkout);

    Vue.prototype.$billing = {
      checkout(params) {
        Event.$emit("billing-checkout", params);
      },

      proforma(params) {
        options.store.commit("Billing/SET_INVOICE_METADATA", params);
        options.router.push({
          name: "Invoice",
          params: { code: params.sourceDocumentNo },
        });
      },

      invoice(invoiceNo) {
        options.router.push({
          name: "Invoice",
          params: { code: invoiceNo },
        });
      },

      receipt(receiptNo) {
        options.router.push({
          name: "Receipt",
          params: { code: receiptNo },
        });
      },
    };
  },
};
